import * as React from 'react';
import { memo } from 'react';

const SvgPlace = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.9 8.91v6.39H8.1V8.91A4.502 4.502 0 0 1 9 0a4.5 4.5 0 0 1 .9 8.91Zm-3.6 2.032v1.824c-2.64.33-4.5 1.082-4.5 1.634 0 .726 3.221 1.8 7.2 1.8s7.2-1.074 7.2-1.8c0-.552-1.86-1.304-4.5-1.634v-1.824c3.65.4 6.3 1.63 6.3 3.458 0 2.256-4.032 3.6-9 3.6s-9-1.344-9-3.6c0-1.829 2.65-3.058 6.3-3.458ZM11.7 4.5a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0Z", fill: "currentColor" })));
const Memo = memo(SvgPlace);

export { Memo as default };
